import { Type } from '@sinclair/typebox';
import { baseCommandSchema } from "./shared.mjs";
export const selectShippingMethodCommandSchema = Type.Intersect([
    baseCommandSchema,
    Type.Object({
        command: Type.Literal('selectShippingMethod'),
        shippingMethodId: Type.String(),
    }),
]);
//# sourceMappingURL=shipping.js.map